type WindowWithChrome = Window & {
  chrome: typeof chrome
}

let windowObj = {} as Window

try {
  windowObj = window
} catch {
  ;(windowObj as WindowWithChrome).chrome = chrome
}

export default windowObj as WindowWithChrome
